import orgApi from '@api/orgApi';
import ItemList from '@components/itemList';
import { orgUrl } from '@components/itemListFilters';
import ItemTile from '@components/itemTile';
import { OrgIcon } from '@components/orgTile';
import useCanCreateInTenant from '@hooks/useCanCreateInTenant';
import { useTranslator } from '@i18n';
import { IconUsersGroup } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';
import { useHandleError } from '@util/errors';

export const Route = createFileRoute('/profile/groups/')({
  component: GroupsList,
});

function GroupsList() {
  const t = useTranslator();
  // Parents included so a group can be shown with the organization it belongs to
  const [orgs, orgsError] = orgApi.lookup({ includeParentOrgs: true }).useCache();
  const canCreate = useCanCreateInTenant('orgs/create');
  // A group's organization is the one it belongs to, which the orgs endpoint knows as parentOrgId
  const parentOrgId = orgUrl.useStore();
  useHandleError(orgsError);

  return (
    <ItemList
      domain="groups"
      icon={<IconUsersGroup />}
      readonly={!canCreate}
      api={orgApi}
      backButton={{ to: '/profile' }}
      title={t('groups.title')}
      listQuery={{ orgType: ['group'], parentOrgId, orgId: undefined }}
      renderItem={(group) => (
        <ItemTile
          avatar={<OrgIcon org={group} />}
          title={group.name}
          subtitle={group.parentOrgId ? orgs?.get(group.parentOrgId)?.name : undefined}
        />
      )}
      availableFilters={['orgId', 'createdOn']}
      // A group belongs to exactly one organization, so filtering means picking that one
      orgTypes={['tenant']}
    />
  );
}
